/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_ErrorInputs */



/**
* | output |
* | --- |
* | "We could not load your calendar. Try again in a moment." |
*
* @param {Agenda_ErrorInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_error = /** @type {((inputs?: Agenda_ErrorInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_ErrorInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden je agenda niet ophalen. Probeer het zo opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu charger votre agenda. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not load your calendar. Try again in a moment.")
});